import { getUserInvestmentsList } from '@dealstack/frontend/shared/dataExchange/services/shareholder/investment.service';
import { useTranslationInvestor } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { ROUTES } from '@dealstack/frontend/investor/pages/Routing/routes';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import { useQuery } from '@tanstack/react-query';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

//iczyryk 22.01.2024 - 72 is maxLength of Investment programme name
const LABEL_STRING_LIMIT = 72;

const truncateString = (label: string): string => {
	if (label.length <= LABEL_STRING_LIMIT) {
		return label;
	}
	return `${label.substring(0, LABEL_STRING_LIMIT)}...`;
};

export const ALL_INVESTMENTS = 'all';

export const useInvestmentsDropdownController = () => {
	const navigate = useNavigate();
	const tInvestor = useTranslationInvestor();
	const { investorId } = useParams();

	const { pathname } = useLocation();

	const getInvestmentListRequest = useQuery({
		queryKey: [API_PATHS.SHAREHOLDER_INVESTMENT_USER_INVESTMENTS_GET],
		queryFn: ({ signal }) => getUserInvestmentsList(signal),
	});
	const [selectedInvestment, setSelectedInvestment] = useState<string>(investorId ?? '');

	const investments = useMemo(() => {
		const mappedInvestmentsList = getInvestmentListRequest.data?.payload?.map((investment) => ({
			label: truncateString(`${investment.entityName} (${investment.programmeName})`),
			value: investment.investorId,
		}));
		mappedInvestmentsList?.push({
			label: tInvestor('valuations.all_companies'),
			value: ALL_INVESTMENTS,
		});
		return mappedInvestmentsList;
	}, [tInvestor, getInvestmentListRequest.data?.payload]);

	const onChange = useCallback(
		(investorId: string) => {
			const isTransactionPage = pathname.includes(ROUTES.TRANSACTIONS);
			if (investorId === ALL_INVESTMENTS) {
				setSelectedInvestment(ALL_INVESTMENTS);
				navigate(isTransactionPage ? ROUTES.TRANSACTIONS : ROUTES.DASHBOARD);
				return;
			}
			setSelectedInvestment(investorId);
			const pathName = isTransactionPage
				? ROUTES.TRANSACTIONS_BY_INVESTOR_ID.replace(':investorId', `${investorId}`)
				: ROUTES.VALUATIONS_AS_DASHBOARD.replace(':investorId?', `${investorId}`);
			navigate(pathName);
		},
		[pathname]
	);

	useEffect(() => {
		onChange(investorId ?? ALL_INVESTMENTS);
	}, [investorId]);

	return {
		investments,
		selectedInvestment,
		setSelectedInvestment,
		onChange,
	};
};
